import { NavigationGuard } from "vue-router";
import store from "shared/store";
import { getGlobalInfo, GlobalInfo } from "shared/api";
import { postLoggedOut } from "modules/base/api";

function deleteAllCookies(): void {
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }

  sessionStorage.clear();
}

const authGuard: NavigationGuard = async (to, from, next): Promise<void> => {
  let currentAuth = store.getters["auth/loggedIn"];

  let info: GlobalInfo = {
    logged_in: true,
    user_id: "",
  };

  try {
    info = await getGlobalInfo();
  } catch (e) {
    try {
      await postLoggedOut();
    } catch (e) {
      // silently fail
    }
  }

  if (currentAuth !== info.logged_in) {
    store.dispatch("auth/setLoggedIn", info.logged_in);
    currentAuth = info.logged_in;
  }

  if (currentAuth) {
    store.commit("auth/clearPostLoginUrl");
  } else {
    deleteAllCookies();
    if (!to.fullPath.startsWith("/login") && !to.fullPath.startsWith("/logout"))
      store.commit("auth/setPostLoginUrl", to.fullPath);
  }

  if (to.meta === undefined || to.meta.auth === undefined) {
    return next();
  }

  const routeAuth = to.meta.auth;
  if (!currentAuth) {
    if (routeAuth) next({ name: "login-request", query: to.query });
    else next();
    return;
  }

  if (!currentAuth && routeAuth) {
    next({ name: "login-request", query: to.query });
  } else if (currentAuth && !routeAuth) {
    next({ name: "home" });
  } else {
    next();
  }
};

export default authGuard;
